import type { Ref } from 'vue';

type IMainInfo = {
  title: string,
  message: string
};
type IAdditionalInfo = {
};
type IRedirectParams = {
  url: string,
  timeout?: number,
  linkTitle?: string,
}
interface IUseNotificationModal {
  isOpenNotificationModal: Ref<boolean>,
  infoNotificationModal: Ref<IMainInfo | undefined>,
  redirectParamsInfoNotificationModal: Ref<IRedirectParams | undefined>,
  openNotificationModal: (mainInfo: IMainInfo, additionalInfo?: IAdditionalInfo, redirectParams?: IRedirectParams) => void;
  closeNotificationModal: () => void;
}

export const useNotificationModal = ():IUseNotificationModal => {
  const isOpenNotificationModal = useState<boolean>('isOpenNotificationModal', () => false);
  const infoNotificationModal = useState<IMainInfo | undefined>('infoNotificationModal', () => undefined);
  const redirectParamsInfoNotificationModal = useState<IRedirectParams | undefined>('redirectParamsInfoNotificationModal', () => undefined);

  const openNotificationModal = (mainInfo: IMainInfo, additionalInfo?: IAdditionalInfo, redirectParams?: IRedirectParams) => {
    infoNotificationModal.value = mainInfo;
    redirectParamsInfoNotificationModal.value = redirectParams;
    isOpenNotificationModal.value = true;
  }
  const closeNotificationModal = () => {
    infoNotificationModal.value = undefined;
    redirectParamsInfoNotificationModal.value = undefined;
    isOpenNotificationModal.value = false;
  }

  return {
    isOpenNotificationModal,
    infoNotificationModal,
    redirectParamsInfoNotificationModal,

    openNotificationModal,
    closeNotificationModal
  };
};
